const wrapToSignedDegrees = (angle: number): number => {
  let normalized = angle;
  if (normalized > 180) normalized -= 360;
  if (normalized < -180) normalized += 360;
  return normalized;
};

export const normalizeCarAngle = (bearing: number): number => wrapToSignedDegrees((bearing - 90 + 360) % 360);

export const normalizePlaneAngle = (bearing: number): number => wrapToSignedDegrees(bearing - 90);

// Signed delta in (-180, 180] so an animation rotates the short way round instead of
// unwinding a full turn when the bearing wraps past 360.
export const shortestAngleDelta = (from: number, to: number): number => ((to - from + 540) % 360) - 180;
